import { render, staticRenderFns } from "./NoticeCenter.vue?vue&type=template&id=2617e8ef&"
import script from "./NoticeCenter.vue?vue&type=script&lang=js&"
export * from "./NoticeCenter.vue?vue&type=script&lang=js&"
import style0 from "./NoticeCenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports